import React from "react";
import Layout from "../../components/Layout/Layout";
import Feedback from "../../components/general/Feedback/Feedback";
import Favorites from "../../components/pages/Favorites/Favorites";

const FavoritesPage: React.FC = () => {
  return (
    <Layout>
      <Favorites />
      <Feedback />
    </Layout>
  );
};

export default FavoritesPage;
